import React from 'react';
import { twMerge } from 'tailwind-merge';
import { BRAND } from '../../lib/content';
type ButtonProps = {
  children: React.ReactNode;
  href?: string;
  variant?: 'primary' | 'secondary';
  size?: 'md' | 'lg';
  className?: string;
  onClick?: () => void;
};
const base = 'inline-flex items-center justify-center gap-2 rounded-full font-display font-extrabold tracking-tight transition-all duration-200 active:scale-[0.98]';
const variants = {
  primary: 'bg-orange text-white shadow-card hover:bg-[#F57F12] hover:shadow-lift',
  secondary: 'bg-white text-navy border-2 border-navy-100 shadow-soft hover:border-sky hover:text-navy-600'
};
const sizes = {
  md: 'px-6 py-3 text-base',
  lg: 'px-8 py-4 text-lg sm:px-10 sm:py-5 sm:text-xl'
};
export function Button({
  children,
  href = BRAND.checkoutUrl,
  variant = 'primary',
  size = 'lg',
  className,
  onClick
}: ButtonProps) {
  return <a href={href} onClick={onClick} className={twMerge(base, variants[variant], sizes[size], className)} data-id="element-569" data-mp="835zjc4g9wtl">
      {children}
    </a>;
}